module.exports = __webpack_public_path__ + "static/media/ic-content.10136331.svg";